<div class="availability-editor">
  <div class="description">
    <p>Use these availability conditions to hide or show this step based on field values.</p>
    <p>No conditions means that the step will always show. If there are any conditions, they must all evaluate to true in order to show the step.</p>
  </div>
  @for (row of availabilityService.conditions; track row; let i = $index) {
    <div class="condition-row">
      <aw-availability-condition [item]="row" [index]="i"></aw-availability-condition>
    </div>
  }
  <div class="new-item" (click)="onNewItemClick()">
    <button id="aw_availability_add" mat-icon-button><mat-icon>add</mat-icon></button>
    <span class="new-item-label">Add new condition</span>
  </div>
  <div class="save-conditions">
    <a  id="aw_availability_save" mat-raised-button class="mat-accent" [disabled]="!availabilityService.canSave" (click)="onSaveClick()">
      <mat-icon>save</mat-icon> Save Conditions
    </a>
  </div>
</div>